import "./assets/design/upload-preparation/fonts.css";
import "@fontsource-variable/inter";
import "@fontsource-variable/jetbrains-mono";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app/App";
import { applyTheme, getTheme } from "./lib/theme";
import { watchIconFonts } from "./platform/icon-fonts";
import "./styles.css";
import "./components/typography.css";
import "./components/interaction.css";
import "./components/icon-fonts.css";

applyTheme(getTheme());
watchIconFonts();
createRoot(document.getElementById("root")!).render(<StrictMode><App /></StrictMode>);
